<h1 mat-dialog-title>{{ 'Clone' | translate }}</h1>
<div mat-dialog-content>
  <ix-input
    [label]="'Enter a Name (optional)' | translate"
    [formControl]="nameControl"
  ></ix-input>
</div>
<mat-dialog-actions>
  <ix-form-actions>
    <button
      mat-button
      ixTest="cancel"
      [matDialogClose]="false"
    >
      {{ 'Cancel' | translate }}
    </button>
    <button
      *ixRequiresRoles="requiredRoles"
      mat-button
      color="primary"
      ixTest="clone"
      (click)="onClone()"
    >
      {{ 'Clone' | translate }}
    </button>
  </ix-form-actions>
</mat-dialog-actions>
